import React, { useEffect } from 'react';

import { track } from '@leagueplatform/analytics';
import { Box, keyframes, styled } from '@leagueplatform/genesis-core';
import { Activity, PointsEarned } from '#constants/types.ts';
import { ToastProgressBanner } from '../toast-progress-banner/toast-progress-banner.view';
import { ToastPoints } from '../toast-points/toast-points.view';

interface RewardsToastContentProps {
  activities?: Activity[] | null;
  pointsEarned?: PointsEarned;
  showMoreActivities: React.Dispatch<React.SetStateAction<boolean>>;
  closeToast: Function;
}

const SlideUpAnimation = keyframes({
  '0%': {
    transform: 'translateY(500px)',
    opacity: 0,
  },
  '70%': {
    transform: 'translateY(-20px)',
    opacity: 1,
  },
  '100%': {
    transform: 'translateY(0)',
    opacity: 1,
  },
});

const ToastContentWrapper = styled(Box, {
  animationName: `${SlideUpAnimation}`,
  animationDuration: '0.65s',
  animationTimingFunction: 'ease-in-out',
});

export const RewardsToastContent = ({
  pointsEarned,
  activities,
  showMoreActivities,

  closeToast,
}: RewardsToastContentProps) => {
  useEffect(() => {
    track('rewards.screen_loaded.progress_toast', {
      sub_detail: activities?.[0]?.name || '',
      action_rewarded: pointsEarned?.name || '',
    });
  }, [activities, pointsEarned]);

  return (
    <ToastContentWrapper
      flexDirection="column"
      css={{ animationFillMode: 'forwards' }}
    >
      {pointsEarned && (
        <ToastPoints
          onlyPoints={!activities}
          title={pointsEarned.name}
          points={pointsEarned.value}
          unit={pointsEarned.unit}
          onClose={closeToast}
        />
      )}
      {activities && (
        <ToastProgressBanner
          onClose={closeToast}
          onlyProgress={!pointsEarned}
          activities={activities}
          showMoreActivities={showMoreActivities}
        />
      )}
    </ToastContentWrapper>
  );
};
